<template>
  <section id="loader">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </section>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "HomeLoader",
  data() {
    return {
    }
  },
  mounted() {
    this.animCircle();
  },
  methods: {
    animCircle() {
      let tl = gsap.timeline({repeat: -1, duration: 0.2});
      tl.fromTo(".circle", {opacity:0, scale: 0.5}, { opacity: 1, scale: 1, stagger: 0.3})
        .to(".circle", {opacity:0, scale: 0.5, stagger: 0.3})
    }
  }
};
</script>

<style lang="scss">
  @import "../scss/global";
  @import "../scss/components/homeLoader";
</style>